import type { EditorView } from 'prosemirror-view';

import type { FullScreenController } from './full-screen-plugin.types';
import type { EditorButton, EditorMode, RtPMPlugin } from '../../editor/types';

export class FullScreenPlugin implements RtPMPlugin {
  public buttons = {
    toggleFullScreen: <EditorButton>{
      icon: 'open-in-full',
      tooltipText: 'wysiwyg.fullscreen',
      isActive: state => this.controller.isEnabled(),
      run: (state, dispatch, origin) => {
        this.controller.toggle();
      },
    },
  };
  private editorView: EditorView;

  constructor(private controller: FullScreenController) {}

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }
}
